/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

export enum VideoSort {
  'title,asc' = 'title,asc',
  'title,desc' = 'title,desc',
  'description,asc' = 'description,asc',
  'description,desc' = 'description,desc',
  'state,asc' = 'state,asc',
  'state,desc' = 'state,desc',
  'created_at,asc' = 'created_at,asc',
  'created_at,desc' = 'created_at,desc'
}
